import { createContext, useContext } from "react";

/** Interface */
interface IPanelContext {
	ref: React.RefObject<HTMLDivElement | null>;
}

interface IPanelsContext {
	resizable?: boolean;
}

/** Context */
export const PanelContext = createContext<IPanelContext>({} as IPanelContext);
export const PanelsContext = createContext<IPanelsContext>({} as IPanelsContext);

/** Hooks */
export function usePanelContext() {
	return useContext(PanelContext);
}

export function usePanelsContext() {
	return useContext(PanelsContext);
}
